import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row d-flex" }
const _hoisted_2 = { class: "col-12 col-md-6 mt-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-text text-start" }
const _hoisted_6 = { class: "col-12 col-md-6 mt-4" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card-text text-start" }
const _hoisted_10 = { class: "card-title d-flex text-start justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _cache[0] || (_cache[0] = _createElementVNode("strong", null, "CPF:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formData.cpf), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Voucher:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.getSolicitation.voucher), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Certificado adquirido:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.getProduto.nome || ' - '), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsWithValuesWithoutCpf, (field) => {
              return (_openBlock(), _createElementBlock("p", {
                key: field.id
              }, [
                _createElementVNode("strong", null, _toDisplayString(field.label) + ": ", 1),
                _createTextVNode(" " + _toDisplayString(field.value), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "btn btn-sm btn-outline-info",
              type: "button",
              to: "form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  name: "pen-to-square",
                  class: "me-2"
                }),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Editar", -1))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}